import type { ImageLike } from 'src/modules/renderings/imageLike';
import type { Rendering } from 'src/modules/renderings/types';

export function isRenderingArray(renderings: any): renderings is Rendering[] {
  return Array.isArray(renderings);
}

export const concatAllImages = (
  rendering?: Rendering,
  jobImages?: ImageLike[],
) => {
  const allImages: ImageLike[] = [];
  if (typeof rendering !== 'undefined') {
    const reversedVersions = rendering.versions.slice().reverse();
    reversedVersions.forEach(version => {
      const versionFiles = version.hiDefRenderingFiles;
      versionFiles.forEach(file => {
        allImages.push(file.image);
      });
    });
  }

  if (typeof jobImages !== 'undefined') {
    jobImages.forEach(jobImage => {
      if (typeof jobImage.blobUrl === 'string') {
        allImages.push(jobImage);
      }
    });
  }

  return allImages;
};
